var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.schema)?_c('b-card-body',[_c('schema-form',{attrs:{"schema":_vm.schema},on:{"submit":_vm.submit},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1):_c('custom-spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }